import { render, staticRenderFns } from "./SubscriptionsPlanContainer.vue?vue&type=template&id=4702b4cb&scoped=true"
import script from "./SubscriptionsPlanContainer.vue?vue&type=script&lang=js"
export * from "./SubscriptionsPlanContainer.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsPlanContainer.vue?vue&type=style&index=0&id=4702b4cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4702b4cb",
  null
  
)

export default component.exports